import React from "react";
import Grid from "@material-ui/core/Grid";
import { toast } from "react-toastify";
import { IPaymentMethodCard } from "./PaymentMethodCard.interface";
import Card from "../../atoms/Card";
import { H5, H6 } from "../../atoms/H/H.styled";
import CardContent from "../../atoms/CardContent";
import Button from "../../atoms/Button";

const PaymentMethodCard = (props: IPaymentMethodCard) => {
  const { paymentMethod, onStatusChange } = props;
  const active = paymentMethod.enabled;
  console.log(paymentMethod);
  return (
    <Grid item xs={12} sm={6} key={paymentMethod.id}>
      <Card>
        <CardContent>
          <Grid container alignItems="center">
            <Grid item xs>
              <H5>{paymentMethod.name}</H5>
              <H6>{paymentMethod._principal}</H6>
            </Grid>
            <Grid>
              <Button
                small
                outlined
                color={active ? "error" : "primary"}
                onClick={() => onStatusChange()}
              >
                {active ? "disable" : "activate"}
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default PaymentMethodCard;
